export default {
  proposalAcceptCounter: {
    path: "buyback/:buybackId/accept",
    name: "proposalAcceptCounter",
  },
  proposalRejectCounter: {
    path: "buyback/:buybackId/reject",
    name: "proposalRejectCounter",
  },
};
